import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgcPipesModule } from '../../pipes/module';
import { AirportLookupService } from '../../services/airport-lookup-service/airport-lookup.service';
// This Module's Components
import { FullAirportListComponent } from './full-airport-list.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    HttpClientModule,
    NgcPipesModule
  ],
  declarations: [FullAirportListComponent],
  exports: [FullAirportListComponent],
  providers: [AirportLookupService]
})
export class FullAirportListModule {}
